// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.5
//   protoc               v4.23.4
// source: channel_message/channel_message.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { ChannelEvent } from "./channel_event";
import { MediaEvent } from "./media_event";

export const protobufPackage = "channel_message";

export interface ChannelMessage {
  id: number;
  channelEvent?: ChannelEvent | undefined;
  mediaEvent?: MediaEvent | undefined;
}

function createBaseChannelMessage(): ChannelMessage {
  return { id: 0, channelEvent: undefined, mediaEvent: undefined };
}

export const ChannelMessage: MessageFns<ChannelMessage> = {
  encode(message: ChannelMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).int32(message.id);
    }
    if (message.channelEvent !== undefined) {
      ChannelEvent.encode(message.channelEvent, writer.uint32(18).fork()).join();
    }
    if (message.mediaEvent !== undefined) {
      MediaEvent.encode(message.mediaEvent, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChannelMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChannelMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.channelEvent = ChannelEvent.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.mediaEvent = MediaEvent.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChannelMessage {
    return {
      id: isSet(object.id) ? globalThis.Number(object.id) : 0,
      channelEvent: isSet(object.channelEvent) ? ChannelEvent.fromJSON(object.channelEvent) : undefined,
      mediaEvent: isSet(object.mediaEvent) ? MediaEvent.fromJSON(object.mediaEvent) : undefined,
    };
  },

  toJSON(message: ChannelMessage): unknown {
    const obj: any = {};
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    if (message.channelEvent !== undefined) {
      obj.channelEvent = ChannelEvent.toJSON(message.channelEvent);
    }
    if (message.mediaEvent !== undefined) {
      obj.mediaEvent = MediaEvent.toJSON(message.mediaEvent);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChannelMessage>, I>>(base?: I): ChannelMessage {
    return ChannelMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChannelMessage>, I>>(object: I): ChannelMessage {
    const message = createBaseChannelMessage();
    message.id = object.id ?? 0;
    message.channelEvent = (object.channelEvent !== undefined && object.channelEvent !== null)
      ? ChannelEvent.fromPartial(object.channelEvent)
      : undefined;
    message.mediaEvent = (object.mediaEvent !== undefined && object.mediaEvent !== null)
      ? MediaEvent.fromPartial(object.mediaEvent)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
